enum Denomination {
  None = 0,

  OneFraction = 1,
  TwoFraction = 2,
  ThreeFraction = 3,
  FourFraction = 4,
  FiveFraction = 5,
  SixFraction = 6,
  SevenFraction = 7,
  EightFraction = 8,
  NineFraction = 9,

  TenFraction = 10,
  TwentyFraction = 20,
  ThirtyFraction = 30,
  FortyFraction = 40,
  FiftyFraction = 50,
  SixtyFraction = 60,
  SeventyFraction = 70,
  EightyFraction = 80,
  NinetyFraction = 90,

  One = 100,
  Two = 200,
  Three = 300,
  Four = 400,
  Five = 500,
  Six = 600,
  Seven = 700,
  Eight = 800,
  Nine = 900,

  Ten = 1000,
  Twenty = 2000,
  Thirty = 3000,
  Forty = 4000,
  Fifty = 5000,
  Sixty = 6000,
  Seventy = 7000,
  Eighty = 8000,
  Ninety = 9000,

  OneHundred = 10000,
  TwoHundred = 20000,
  ThreeHundred = 30000,
  FourHundred = 40000,
  FiveHundred = 50000,
  SixHundred = 60000,
  SevenHundred = 70000,
  EightHundred = 80000,
  NineHundred = 90000,

  OneThousand = 100000,
  TwoThousand = 200000,
  ThreeThousand = 300000,
  FourThousand = 400000,
  FiveThousand = 500000,
  SixThousand = 600000,
  SevenThousand = 700000,
  EightThousand = 800000,
  NineThousand = 900000

  // TenThousand = 1000000
}

export default Denomination
